import { gql } from "@apollo/client";
import DropdownInput from "components/common/form/inputs/dropdown/DropdownInput";
import { graph } from "config/axios-context";
import { DropdownInputPropsType } from "types/form-types";
import { WalletDropdownQuery, WalletDropdownQueryVariables, WalletFilterInput, WalletSortInput } from "types/graphql";
import { appendFilters } from "utilities/datalist/datalist-filter-utilities";

type WalletDropdownModel = {
    id: number,
    name: string,
    balance?: number | null
}

type WalletDropdownProps = Omit<DropdownInputPropsType<WalletDropdownModel>, 'dataSource' | 'getItemId' | 'view'> & {
    personId?: number
};

const query = gql`
query WalletDropdown($where: WalletFilterInput, $sort: [WalletSortInput!], $take: Int, $skip: Int) {
    wallets{
        items (where: $where, order: $sort, skip: $skip, take: $take) {
            id,
            name,
            balance
        }
        count(where: $where)
    }
}
`;

const WalletDropdown = (props: WalletDropdownProps) => {
    const walletDropDown: DropdownInputPropsType<WalletDropdownModel, WalletFilterInput, WalletSortInput> = {
        dataSource: {
            request: async params => {
                let variables: WalletDropdownQueryVariables = {
                    where: params.filters,
                    sort: params.sort,
                    take: params.take,
                    skip: params.skip
                };

                if (params.searchText) {
                    variables.where = {
                        or: [
                            {
                                name: {
                                    contains: params.searchText
                                }
                            }
                        ]
                    }

                    variables.where = appendFilters(variables.where, params.filters);
                }

                variables.where = appendFilters(variables.where, {
                    personId: {
                        eq: props.personId || 0
                    },
                    archived: {
                        eq: false
                    }
                });

                const response = await graph<WalletDropdownQuery, WalletDropdownQueryVariables>({
                    query: query,
                    variables: variables
                });

                if (response.errors) {
                    throw response.errors;
                }

                return response.data!.wallets!.items as WalletDropdownModel[];
            },
            search: 'on'
        },
        getItemId: i => i.id,
        view: {
            inputView: i => i ? `${i?.name} (${i?.balance})` : '',
        },
        label: 'fields.wallet.name',
        ...props
    }

    return (
        <DropdownInput
            {...walletDropDown}
            disabled={!props.personId}
        />
    );
};

export default WalletDropdown;
